import { Navigate, Outlet } from "react-router-dom";
import { isToken } from "../../utils/constant";

const PrivateRoutes = () => {
  const sessionExpired = localStorage.getItem("SESSION_EXPIRED") === "true";

  if (sessionExpired) {
    return <Outlet />;
  }

  return isToken() ? <Outlet /> : <Navigate to="/signin" />;
};

export default PrivateRoutes;
